import api from './api';

export const listIngestedEvidence = (params = {}) =>
  api.get('/admin/email-ingestion', { params });

export const ingestRawEmailEvidence = (data) =>
  api.post('/admin/email-ingestion', data);
